import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const CreateWebHook = async (
  userId,
  catalogItemId,
  directLinkId,
  priorities,
  id,
  shopUrl,
  shopName,
  userDetails
) => {
  const url = process.env.REACT_APP_API_URL;

  try {
    const response = await axios.post(`${url}/api/create_webhooks`, {
      userId,
      catalogItemId,
      directLinkId,
      priorities,
      id,
      shopUrl,
      shopName,
      userDetails
    });
    toast.success(response.data.message);
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage);
      } else {
        toast.error(error.message);
      }
    } else if (error.request) {
      toast.error(error.message);
    } else {
      toast.error(error.message);
    }
  }
};
